import { useQuery } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';
import { QueryKeys } from '../../shared';
import { IRunReportFilter } from '../models/run-report.model';
import { IRunReportSort } from '../models/filter.model';
import { IReportResult } from '../models/report-result.model';

async function runReport(id: string, filters: IRunReportFilter[], sort?: IRunReportSort): Promise<IReportResult> {
    const { data } = await axios.post(`/reporting/reports/${id}/run`, {
        filters,
        sort,
    });
    return data;
}

export const useReportResult = (id: string, filters: IRunReportFilter[], sort?: IRunReportSort, enabled?: boolean) => {
    return useQuery<IReportResult, AxiosError>({
        queryKey: [QueryKeys.ReportResult, id, filters, sort],
        queryFn: () => runReport(id, filters, sort),
        enabled,
    });
};
